import { getCityId } from './cityMappingUtils';
import { getFanMemberByActivityId } from '../config/fanMembersConfig';

// Member ID suffix — must match beat/internal/fanbase/member_id.go:
// {YY WIB}{cityId 4 digits}{sequence 5 digits} (prefix from activity.memberPrefix)
//
// Jemari/JL: always global registration id (printed cards must not change).
// Menaone: activity-scoped memberNumber when present.

const wibYear = (createdAt) => {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Jakarta',
        year: 'numeric',
    }).formatToParts(new Date(createdAt));
    const year = parts.find((p) => p.type === 'year')?.value || '00';
    return year.slice(-2);
};

const resolveMemberSequence = (registrationData) => {
    const { id, memberNumber, activityId, activity } = registrationData;
    const resolvedActivityId = activityId ?? activity?.id;
    const fanMember = getFanMemberByActivityId(resolvedActivityId);

    if (
        fanMember?.activityScopedMemberNumber &&
        memberNumber != null &&
        memberNumber > 0
    ) {
        return memberNumber;
    }
    return id;
};

export const generateMemberId = (registrationData) => {
    const { createdAt, formSubmissionValues } = registrationData;

    const year = wibYear(createdAt);

    const cityField = formSubmissionValues?.find((value) => value.formField.name === 'Kota');
    const city = cityField?.value || 'Unknown';
    const cityId = (getCityId(city) ?? 999).toString().padStart(4, '0');

    const seq = resolveMemberSequence(registrationData);
    const formattedId = seq.toString().padStart(5, '0');

    return `${year}${cityId}${formattedId}`;
};
